import React from 'react';
import { HeroHeaderSection } from '../../../../components/HeroHeaderSection';
import { PlanSummaryDetails } from './components/PlanSummaryDetails';
import { HtmlIds } from '../../../../constants/html-ids';
import backgroundDesktop from '../../../../assets/hero-header-backgrounds/wellness-desktop-v2.png';
import backgroundMobile from '../../../../assets/hero-header-backgrounds/wellness-mobile-v2.png';
import { Flex } from '../../../../wag-react/next-components/Flex';
import { Box } from '../../../../wag-react/next-components/box';
import { Button } from '../../../../wag-react/next-components/button';
export const WellnessHeroHeaderSection = () => <HeroHeaderSection backgroundImage={[`url(${backgroundMobile})`, null, `url(${backgroundDesktop})`, null]} ctaBlock={<Flex flexDirection="column" alignItems={['center', null, 'flex-start', null]}>
        <Box maxWidth={['350px', null, 'unset', null]}>
          <PlanSummaryDetails />
        </Box>
        <Box>
          <Button variant="contained" size="large" href={`#${HtmlIds.WELLNESS_PLANS_SECTION}`}>
            Compare plans
          </Button>
        </Box>
      </Flex>} darkText height={['580px', '840px', '552px', '756px']} titleText="Peace of mind for your pet's wellness" titleTextProps={{
  maxWidth: ['268px', '600px', '560px'],
  textAlign: ['center', null, 'left'],
  color: '#474747'
}} subtitleText="Wag! Wellness covers your pet's routine healthcare needs" subtitleTextProps={{
  maxWidth: ['100%', null, '552px'],
  textAlign: ['center', null, 'left']
}} data-sentry-element="HeroHeaderSection" data-sentry-component="WellnessHeroHeaderSection" data-sentry-source-file="index.tsx" />;